/**
 * Maps a `SocialLink.platform` value to the logo the footer draws for it.
 *
 * Keyed by the exact strings in `SOCIAL_PLATFORMS` below, which the admin's
 * platform picker (`SocialLinksEditor.vue`) is constrained to. An operator's
 * stored `platform` is free text on the backend, so a value outside the
 * list — a link
 * created before the picker existed, or added directly against the API —
 * has no entry here and `iconFor()` answers `null` for it; the footer falls
 * back to a plain text link rather than drawing a broken image.
 */
const SOCIAL_ICONS: Record<string, string> = {
  Instagram: '/assets/social/instagram.svg',
  Facebook: '/assets/social/facebook.svg',
  X: '/assets/social/x.svg',
  Threads: '/assets/social/threads.svg',
  Discord: '/assets/social/discord.svg',
  YouTube: '/assets/social/youtube.svg',
  Snapchat: '/assets/social/snapchat.svg',
  Telegram: '/assets/social/telegram.svg',
};

/** The platforms an admin can pick, with the label shown in the dropdown. */
export const SOCIAL_PLATFORMS: { value: string; label: string }[] = [
  { value: 'Instagram', label: 'Instagram' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'X', label: 'X (Twitter)' },
  { value: 'Threads', label: 'Threads' },
  { value: 'Discord', label: 'Discord' },
  { value: 'YouTube', label: 'YouTube' },
  { value: 'Snapchat', label: 'Snapchat' },
  { value: 'Telegram', label: 'Telegram' },
];

export function iconFor(platform: string): string | null {
  return SOCIAL_ICONS[platform] ?? null;
}
